import { useBooleanFlagValue } from '@openfeature/react-sdk';

export const useDataExtractionMismatchAlertPhase2Flag = (): boolean =>
  useBooleanFlagValue('data-extraction-mismatch-alert-phase-2', false);
